import renameFunc from "utils/helpers/renameFunc";
import { camelCase as _camelCase, get as _get } from "lodash";

export const actionTypes = {
  CREATE_ORDER_REQUEST: "CREATE_ORDER_REQUEST 🚀 💬",
  CREATE_ORDER_SUCCESS: "CREATE_ORDER_SUCCESS 🚀 ✅",
  CREATE_ORDER_FAILED: "CREATE_ORDER_FAILED 🚀 ❌",

  DELETE_ORDER_REQUEST: "DELETE_ORDER_REQUEST 🚀 💬",
  DELETE_ORDER_SUCCESS: "DELETE_ORDER_SUCCESS 🚀 ✅",
  DELETE_ORDER_FAILED: "DELETE_ORDER_FAILED 🚀 ❌",

  ORDERS_REQUEST: "ORDERS_REQUEST 🚀 💬",
  ORDERS_REQUEST_SUCCESS: "ORDERS_REQUEST_SUCCESS 🚀 ✅",
  ORDERS_REQUEST_FAILED: "ORDERS_REQUEST_FAILED 🚀 ❌",

  ORDERS_ADD_TO_FAV: "ORDERS_ADD_TO_FAV 🚀 ❌",
  ORDERS_DEL_TO_FAV: "ORDERS_DEL_TO_FAV 🚀 ❌",
};
// helper function automatically generate ACTION CREATORS!
export const actions = Object.keys(actionTypes).reduce((accum, id) => {
  const creatorName = _camelCase(id);

  const creatorFunction = function _(payload) {
    return {
      type: _get(actionTypes, id),
      payload,
    };
  };

  // eslint-disable-next-line no-param-reassign
  accum[creatorName] = renameFunc(creatorFunction, creatorName);
  return accum;
}, {});
